module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-120x120-f6f4ebe5819d3741d1cfa3ce2b8a5d5c.png";